import { useEffect, useState } from "react";
import { io } from "socket.io-client";
import { URL } from "../../store/utils";
import { handleSocketSessionExpiry } from "../../utils/dashboardUtils";
import useLatestToken, { attachTokenOnReconnect } from "../useLatestToken";

/**
 * Bakım sekmesinin TEK soket bağlantısı (askı sensörü + operasyon durumu
 * aynı bağlantıyı paylaşır). Sekme açıkken yaşar, kapanınca kopar.
 * `ready` yalnız server `authenticated` yaydıktan sonra true olur — izleme
 * olayları bundan önce gönderilirse sessizce düşer.
 */
export default function useMaintenanceSocket(token) {
  const { hasToken, tokenRef } = useLatestToken(token);
  const [socket, setSocket] = useState(null);
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!hasToken) return undefined;
    const s = io(URL.url, {
      transports: ["websocket", "polling"],
      timeout: 5000,
      query: { token: tokenRef.current },
    });
    attachTokenOnReconnect(s, tokenRef); // #142
    setSocket(s);
    setError(null);
    s.on("authenticated", () => {
      setReady(true);
      setError(null);
    });
    s.on("disconnect", () => setReady(false));
    s.on("connect_error", () => setReady(false));
    s.on("error", (payload) => {
      const reason = payload?.reason;
      if (reason && handleSocketSessionExpiry(reason)) return;
      setReady(false);
      setError(reason || "error");
    });
    return () => {
      s.disconnect();
      setSocket(null);
      setReady(false);
    };
  }, [hasToken, tokenRef]);

  return { socket, ready, error };
}
